const clubsquery = `
{
  newAndClubCollection {
    items {
      clubName
      password
    }
  }
}`;

const helpquery = `
{
        learningResourcesCollection {
          items {
            learningResources {
              json
            }
          }
        }
}`;

export const contentful = (arg) => {
  const query = arg === "clubs" ? clubsquery : helpquery;
  return fetch(
    `https://graphql.contentful.com/content/v1/spaces/6bg98pzcar3c/`,
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer RA5MbDNpWtfs25NZTlUirI8wSB4_aHyD8uuyQK0cTGo",
      },
      body: JSON.stringify({ query }),
    }
  ).then((response) => {
    return response.json();
  });
};
